<template>
  <div class="board user-board">
    <user-nav />
    <div class="tile is-ancestor">
      <div class="tile is-5 is-parent is-vertical">
        <div class="tile is-child">
          <user-map ref="map" />
        </div>
        <div class="tile is-child">
          <user-profile ref="profile" />
        </div>
      </div>
      <div class="tile is-7 is-parent is-dark">
        <div class="tile is-6 is-child">
          <user-timeline />
        </div>
        <div class="tile is-6 is-vertical has-margin-left">
          <div class="tile is-child">
            <user-segments ref="segments" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import store from 'store/index';
import notifications from 'services/Notifications';
import UserSegments from './modules/UserSegments';
import UserNav from './modules/UserNav';
import UserMap from './modules/UserMap';
import UserProfile from './modules/UserProfile';
import UserTimeline from './modules/UserTimeline';
import { flags } from 'config';
import { configs } from '../../../config';

export default {
  components: {
    UserNav,
    UserMap,
    UserProfile,
    UserSegments,
    UserTimeline,
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
  },

  beforeRouteEnter(to, from, next) {
    const id = to.params.userId;
    const day = to.query.day || format(new Date(), 'YYYY-MM-DD');

    store
      .dispatch('user/loadUser', { id, day })
      .then(user => {
        if (user.application_id !== to.params.appId) {
          return next({
            name: to.name,
            params: {
              ...to.params,
              appId: user.application_id,
            },
          });
        }

        return next();
      })
      .catch(err => {
        notifications.add(err.message);
      });
  },

  mounted() {
    // this.$refs.profile.$on('location', this.onLocation)
  },

  methods: {
    onLocation(location) {
      // this.$refs.map.flyTo(location)
    },
  },

  watch: {
    $route(to, from) {
      const { day } = to.query;
      if (day) {
        store.dispatch('user/loadDay', day).catch(err => {
          notifications.add(err.message);
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.tile {
  &.is-ancestor {
    min-height: calc(100vh - 104px);
    max-height: calc(100vh - 104px);
    margin: 0;
  }

  &.is-child {
    flex: 1;
  }

  &.is-dark {
    // background-color: #323435;
    background-color: rgba($black, 0.12);
  }

  &.has-margin-left {
    margin-left: 0.5rem;
  }
}
</style>

<style lang="scss">
@import '~scss/utilities/initial-variables.scss';
@import '~scss/utilities/derived-variables.scss';

.user-board {
  .card {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  // TODO look at all has-* classes in HTMl and styles, and migrate to UiCard
  .card-header {
    align-items: center;
    padding: 0.796875rem 1rem;

    &.has-tabs {
      padding-top: 0.515625rem;
      padding-bottom: 0.515625rem;
    }

    &.has-dropdown {
      padding-top: 0.515625rem;
      padding-bottom: 0.515625rem;
    }

    .level {
      flex: 1;
    }

    .tooltip-container {
      margin-left: 0.375rem;

      i {
        font-size: $size-small;
        opacity: 0.72;
      }
    }
  }

  .card-header-title {
    margin-top: 0;
  }
}
</style>
